module.exports = __webpack_public_path__ + "img/suwang-night-balanced.6a0cb125.png";